/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { Icon } from "@iconify/react";
import { Fragment } from "react";

const ReferralInfoBoxInMissions = ({
    user,
    shortenReferralLink,
    handleCopyUserReferralLink,
    userReferrals,
    userReferralsLoading,
    signupReferralRewards,
    signupReferralRewardsLoading,
    setSignupBonusDialogOpen,
    setActivityBonusDialogOpen
  }) => {
  return (
    <Fragment>
      <div className="bg-metaxseed-content-gray flex justify-center items-center px-8 py-4 rounded-xl h-full shadow-lg mb-4">
        <ul className="list space-y-8">
          <li className="flex space-x-8 items-center rtl:space-x-reverse">
            <Icon icon="fa:users" className="flex-none text-2xl text-white" />
            <div className="flex-1">
              <div className="uppercase text-sm text-metaxseed-text-gray font-semibold mb-2 leading-[12px] gothamBook">User Referral Link</div>
              <div className="flex justify-start items-center">
                <div className="w-full text-sm gothamBook cursor-pointer rounded-md text-white overflow-hidden" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                  <span>{shortenReferralLink(`https://www.metaxseed.io/?referrer=${user?.referral_alias || user?.uid || "Not Connected"}`, window.innerWidth)}</span>
                </div>
                <button onClick={handleCopyUserReferralLink} className="cursor-pointer">
                  <Icon icon="solar:copy-linear" className="text-metaxseed-text-gray ml-2" />
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div className="flex justify-between items-center mb-4 w-full">
        <div className="flex justify-start items-center">
          <div className="w-10 h-5 bg-metaxseed-content-gray rounded-lg mr-4"></div>
          <span className="gothamBook md:text-base text-sm">User Referrals Click Count:</span>
        </div>
        <div className="flex justify-start items-center">
          <span className="gothamBook md:text-base text-sm">{userReferrals?.click_count || 0}</span>
        </div>
      </div>

      <div className="flex justify-between items-center mb-4 w-full">
        <div className="flex justify-start items-center">
          <div className="w-10 h-5 bg-metaxseed-content-gray rounded-lg mr-4"></div>
          <span className="gothamBook md:text-base text-sm">Signup Referrals Count:</span>
        </div>
        <div className="flex justify-start items-center">
          <span className="gothamBook md:text-base text-sm">
          {userReferrals?.signup_count || 0}
            </span>
        </div>
      </div>

      <div className="flex justify-between items-center w-full">
        <div className="flex justify-start items-center">
          <div className="w-10 h-5 bg-metaxseed-content-gray rounded-lg mr-4"></div>
          <span className="gothamBook md:text-base text-sm">Active Referrals Count:</span>
        </div>
        <div className="flex justify-start items-center">
          <span className="gothamBook md:text-base text-sm">
          {userReferrals?.active_count || 0}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default ReferralInfoBoxInMissions;
